module.exports = __webpack_public_path__ + "img/angle-iron.503614b0.svg";